import { render, staticRenderFns } from "./UserAvatarList.vue?vue&type=template&id=93d77880&scoped=true"
import script from "./UserAvatarList.vue?vue&type=script&lang=js"
export * from "./UserAvatarList.vue?vue&type=script&lang=js"
import style0 from "./UserAvatarList.vue?vue&type=style&index=0&id=93d77880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d77880",
  null
  
)

export default component.exports